import React from 'react'
import { locationShape } from 'react-router'
import ZazzleCreateEvent from './ZazzleCreateEvent/ZazzleCreateEvent'
import NormalCreateEvent from './NormalCreateEvent/NormalCreateEvent'

const CreateEventContainer = ({ location }) => {
  const queryParams = location.query || {}

  if (queryParams.design_id) {
    const image_url = decodeURIComponent(queryParams.image_url || '')
    const source = queryParams.source || 'webpage'
    return <ZazzleCreateEvent designId={queryParams.design_id} imageUrl={image_url} source={source} />
  }

  return <NormalCreateEvent />
}

CreateEventContainer.propTypes = {
  location: locationShape
}

export default CreateEventContainer
